import axios from "axios";
// const axios = () => import(/* webpackChunkName: "axios" */ "axios");
export default () => {
  return axios.create({
    // baseURL: `http://192.168.1.41:8081/api`,
    baseURL: "/api",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    }
  });
};
